import { AirspaceJurisdictionDto } from '@flyfreely-portal-ui/flyfreely';

export function compareJurisdictions(
    a: AirspaceJurisdictionDto,
    b: AirspaceJurisdictionDto
) {
    return a.name.localeCompare(b.name);
}
